import { put, select } from 'redux-saga/effects';
import * as actions from './meeting-folder.actions';
import { meetingFolderSelectors } from './meeting-folder.selectors';

export function* storeMeetingFolder(meetingFolder: any) {
  yield put(actions.storeMeetingFolder(meetingFolder));
  return meetingFolder;
}

export function* clearMeetingFolder(meetingId: any) {
  yield put(actions.clearMeetingFolder(meetingId));
}

export function* clearAllMeetingFolders() {
  const meetingFoldersIds = yield select(meetingFolderSelectors.selectResourceIds);
  yield put(actions.clearMeetingFolder(meetingFoldersIds));
}
